
import { CompanyAiInsights } from "../Model/AiInsightObjects";
import { COMPANY_AI_INSIGHTS } from "../Reducers/companyAiInsightsReducer";
import { fetchCompanyAiInsights } from "../Util/queries";

export const getCompanyAiInsights = (companyId) => async (dispatch) => {
    try {
        const response = await fetchCompanyAiInsights(companyId);
        dispatch({
            type: COMPANY_AI_INSIGHTS,
            payload: new CompanyAiInsights(companyId, response.data)
        });

    } catch (error) {
        console.error(error);
        dispatch({
            type: COMPANY_AI_INSIGHTS,
            payload: new CompanyAiInsights(companyId, {})
        });
    }
}
